// src/api/adminWorkplace.js
import adminRequest from "./adminClient";


export function fetchWorkplaces(params = {}) {
    const qs = new URLSearchParams(
        Object.fromEntries(
            Object.entries(params).filter(([_, v]) => v !== undefined && v !== null && v !== "")
        )
    ).toString();

    const path = qs ? `/workplaces?${qs}` : "/workplaces";
    return adminRequest(path, { method: "GET" });
}

/**
 * 사업장 생성
 * POST /workplaces
 * body: { code, name, address?, is_active? }
 */
export function createWorkplace(payload) {
    return adminRequest("/workplaces", {
        method: "POST",
        body: payload, // adminClient가 JSON으로 보내줌
    });
}

/**
 * 사업장 수정
 * PATCH /workplaces/:id
 * body: { name?, address?, is_active? }
 */
export function updateWorkplace(id, payload) {
    return adminRequest(`/workplaces/${id}`, {
        method: "PATCH",
        body: payload,
    });
}

/**
 * DELETE /workplaces/:id
 */
export function deleteWorkplace(id) {
    return adminRequest(`/workplaces/${id}`, {
        method: "DELETE",
    });
}
